import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import Badge from 'v3/components/Badge';
import Text from 'v3/components/Text';
import Tooltip from 'v3/components/Tooltip';
import theme from 'v3/theme';
import { StyledCardHeader } from './styles';

export default function CardHeaderComponent({
  isOpen,
  onToggleCard,
  label = '',
  tooltipContent = '',
  rightSection = null,
  totalsSection = null,
  styles = {},
  hasTagsRow = true,
  tagsContent = [],
}) {
  const shouldShowTagsRow = hasTagsRow && isOpen === false;
  return (
    <StyledCardHeader style={{ ...styles }}>
      {isOpen ? (
        <button type="button" onClick={onToggleCard} className="arrowButton">
          <MdKeyboardArrowUp size={24} />
        </button>
      ) : (
        <button type="button" onClick={onToggleCard} className="arrowButton">
          <MdKeyboardArrowDown size={24} />
        </button>
      )}
      <Text as="p" className="label">
        {label}
        <Tooltip
          content={
            <Text type="label" color="white">
              {tooltipContent}
            </Text>
          }
        >
          <FaQuestionCircle style={{ color: theme.colors.light_blue }} />
        </Tooltip>
      </Text>
      {isOpen && !!rightSection && <div>{rightSection}</div>}
      {isOpen === false && <div>{totalsSection}</div>}
      {shouldShowTagsRow && (
        <div className="tagsRow">
          {tagsContent.map((tag) => {
            return (
              <Badge variant="secondary" key={tag} pill style={{ padding: '0.5rem' }}>
                {tag}
              </Badge>
            );
          })}
        </div>
      )}
    </StyledCardHeader>
  );
}
